export enum VehicleSorting {
  PRICE_ASC = 'PriceAsc',
  PRICE_DESC = 'PriceDesc',
  NAME_ASC = 'NameAsc',
  NAME_DESC = 'NameDesc',
}
